import { m } from 'framer-motion';
// @mui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// components
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  imageAlt?: string;
  image?: string;
  icon?: string;
  title: string;
  text: any;
};

export default function TabTemplate({ imageAlt, image, icon, title, text }: Props) {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      textAlign="center"
      minHeight={500}
    >
      {image && imageAlt && (
        <Box
          component={m.img}
          alt={imageAlt}
          src={image}
          sx={{
            maxWidth: 'auto',
            maxHeight: 180,
            p: 5,
          }}
        />
      )}
      {icon && <Iconify icon={icon} width={80} mb={4} sx={{ color: 'primary.light' }} />}
      <Typography variant="h3" gutterBottom>
        {title}
      </Typography>
      <Box
        maxWidth={700}
        sx={{
          mt: 2,
          '& ul': {
            listStyleType: 'disc',
            paddingLeft: theme.spacing(4),
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            textAlign: 'left',
          },
          '& li': {
            marginBottom: theme.spacing(1),
          },
        }}
      >
        <Typography variant="body1" sx={{ lineHeight: 1.8, fontSize: '1.3em' }}>
          {text}
        </Typography>
      </Box>
    </Box>
  );
}
